// patterns

export const patternDefs = 
{
    "indicators-chart-series-pattern-0": {
        "id": "indicators-chart-series-pattern-0",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--chart-color-0)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-1": {
        "id": "indicators-chart-series-pattern-1",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--chart-color-1)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(90)"
    },
    "indicators-chart-series-pattern-2": {
        "id": "indicators-chart-series-pattern-2",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--chart-color-2)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-3": {
        "id": "indicators-chart-series-pattern-3",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--chart-color-3)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(45)"
    },
    "indicators-chart-series-pattern-4": {
        "id": "indicators-chart-series-pattern-4",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--chart-color-4)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-5": {
        "id": "indicators-chart-series-pattern-5",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--chart-color-5)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-6": {
        "id": "indicators-chart-series-pattern-6",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M10 0 V20 M0 10 H20",
                "stroke": "var(--chart-color-6)",
                "stroke-width": 10
            },
            {
                "tagName": "path",
                "d": "M20 0 V20 M0 20 H20",
                "stroke": "var(--chart-color-6)",
                "stroke-width": 2
            }
        ],
        "patternName": "diamonds",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.3) rotate(45)"
    },
    "indicators-chart-series-pattern-7": {
        "id": "indicators-chart-series-pattern-7",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-7)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(45)"
    },
    "indicators-chart-series-pattern-8": {
        "id": "indicators-chart-series-pattern-8",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-8)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles2",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(0)"
    },
    "indicators-chart-series-pattern-9": {
        "id": "indicators-chart-series-pattern-9",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--chart-color-9)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks45",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(45)"
    },
    "indicators-chart-series-pattern-10": {
        "id": "indicators-chart-series-pattern-10",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--chart-color-10)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines45",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(135)"
    },
    "indicators-chart-series-pattern-11": {
        "id": "indicators-chart-series-pattern-11",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--chart-color-11)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-12": {
        "id": "indicators-chart-series-pattern-12",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--chart-color-12)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle45",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(90)"
    },
    "indicators-chart-series-pattern-13": {
        "id": "indicators-chart-series-pattern-13",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--chart-color-13)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-14": {
        "id": "indicators-chart-series-pattern-14",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--chart-color-14)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-15": {
        "id": "indicators-chart-series-pattern-15",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M10 0 V20 M0 10 H20",
                "stroke": "var(--chart-color-15)",
                "stroke-width": 10
            },
            {
                "tagName": "path",
                "d": "M20 0 V20 M0 20 H20",
                "stroke": "var(--chart-color-15)",
                "stroke-width": 2
            }
        ],
        "patternName": "diamonds",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.3) rotate(45)"
    },
    "indicators-chart-series-pattern-16": {
        "id": "indicators-chart-series-pattern-16",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-16)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(45)"
    },
    "indicators-chart-series-pattern-17": {
        "id": "indicators-chart-series-pattern-17",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-17)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles2",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(0)"
    },
    "indicators-chart-series-pattern-18": {
        "id": "indicators-chart-series-pattern-18",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--chart-color-18)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks90",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(90)"
    },
    "indicators-chart-series-pattern-19": {
        "id": "indicators-chart-series-pattern-19",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--chart-color-19)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines90",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(180)"
    },
    "indicators-chart-series-pattern-20": {
        "id": "indicators-chart-series-pattern-20",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--chart-color-20)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-21": {
        "id": "indicators-chart-series-pattern-21",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--chart-color-21)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle90",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(135)"
    },
    "indicators-chart-series-pattern-22": {
        "id": "indicators-chart-series-pattern-22",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--chart-color-22)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-23": {
        "id": "indicators-chart-series-pattern-23",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--chart-color-23)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-24": {
        "id": "indicators-chart-series-pattern-24",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M10 0 V20 M0 10 H20",
                "stroke": "var(--chart-color-24)",
                "stroke-width": 10
            },
            {
                "tagName": "path",
                "d": "M20 0 V20 M0 20 H20",
                "stroke": "var(--chart-color-24)",
                "stroke-width": 2
            }
        ],
        "patternName": "diamonds",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.3) rotate(45)"
    },
    "indicators-chart-series-pattern-25": {
        "id": "indicators-chart-series-pattern-25",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-25)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(45)"
    },
    "indicators-chart-series-pattern-26": {
        "id": "indicators-chart-series-pattern-26",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-26)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles2",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(0)"
    },
    "indicators-chart-series-pattern-27": {
        "id": "indicators-chart-series-pattern-27",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--chart-color-27)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks135",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(135)"
    },
    "indicators-chart-series-pattern-28": {
        "id": "indicators-chart-series-pattern-28",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--chart-color-28)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines135",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(225)"
    },
    "indicators-chart-series-pattern-29": {
        "id": "indicators-chart-series-pattern-29",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--chart-color-29)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-30": {
        "id": "indicators-chart-series-pattern-30",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--chart-color-30)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle135",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(180)"
    },
    "indicators-chart-series-pattern-31": {
        "id": "indicators-chart-series-pattern-31",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--chart-color-31)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-32": {
        "id": "indicators-chart-series-pattern-32",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--chart-color-32)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-33": {
        "id": "indicators-chart-series-pattern-33",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M10 0 V20 M0 10 H20",
                "stroke": "var(--chart-color-33)",
                "stroke-width": 10
            },
            {
                "tagName": "path",
                "d": "M20 0 V20 M0 20 H20",
                "stroke": "var(--chart-color-33)",
                "stroke-width": 2
            }
        ],
        "patternName": "diamonds",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.3) rotate(45)"
    },
    "indicators-chart-series-pattern-34": {
        "id": "indicators-chart-series-pattern-34",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-34)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(45)"
    },
    "indicators-chart-series-pattern-35": {
        "id": "indicators-chart-series-pattern-35",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-35)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles2",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(0)"
    },
    "indicators-chart-series-pattern-36": {
        "id": "indicators-chart-series-pattern-36",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--chart-color-36)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-37": {
        "id": "indicators-chart-series-pattern-37",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--chart-color-37)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(90)"
    },
    "indicators-chart-series-pattern-38": {
        "id": "indicators-chart-series-pattern-38",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--chart-color-38)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-39": {
        "id": "indicators-chart-series-pattern-39",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--chart-color-39)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(45)"
    },
    "indicators-chart-series-pattern-40": {
        "id": "indicators-chart-series-pattern-40",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--chart-color-40)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-41": {
        "id": "indicators-chart-series-pattern-41",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--chart-color-41)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-42": {
        "id": "indicators-chart-series-pattern-42",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M10 0 V20 M0 10 H20",
                "stroke": "var(--chart-color-42)",
                "stroke-width": 10
            },
            {
                "tagName": "path",
                "d": "M20 0 V20 M0 20 H20",
                "stroke": "var(--chart-color-42)",
                "stroke-width": 2
            }
        ],
        "patternName": "diamonds",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.3) rotate(45)"
    },
    "indicators-chart-series-pattern-43": {
        "id": "indicators-chart-series-pattern-43",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-43)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(45)"
    },
    "indicators-chart-series-pattern-44": {
        "id": "indicators-chart-series-pattern-44",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-44)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles2",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(0)"
    },
    "indicators-chart-series-pattern-45": {
        "id": "indicators-chart-series-pattern-45",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--chart-color-45)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks45",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(45)"
    },
    "indicators-chart-series-pattern-46": {
        "id": "indicators-chart-series-pattern-46",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--chart-color-46)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines45",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(135)"
    },
    "indicators-chart-series-pattern-47": {
        "id": "indicators-chart-series-pattern-47",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--chart-color-47)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-48": {
        "id": "indicators-chart-series-pattern-48",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--chart-color-48)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle45",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(90)"
    },
    "indicators-chart-series-pattern-49": {
        "id": "indicators-chart-series-pattern-49",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--chart-color-49)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-50": {
        "id": "indicators-chart-series-pattern-50",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--chart-color-50)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-51": {
        "id": "indicators-chart-series-pattern-51",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M10 0 V20 M0 10 H20",
                "stroke": "var(--chart-color-51)",
                "stroke-width": 10
            },
            {
                "tagName": "path",
                "d": "M20 0 V20 M0 20 H20",
                "stroke": "var(--chart-color-51)",
                "stroke-width": 2
            }
        ],
        "patternName": "diamonds",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.3) rotate(45)"
    },
    "indicators-chart-series-pattern-52": {
        "id": "indicators-chart-series-pattern-52",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-52)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(45)"
    },
    "indicators-chart-series-pattern-53": {
        "id": "indicators-chart-series-pattern-53",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-53)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles2",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(0)"
    },
    "indicators-chart-series-pattern-54": {
        "id": "indicators-chart-series-pattern-54",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--chart-color-54)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks90",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(90)"
    },
    "indicators-chart-series-pattern-55": {
        "id": "indicators-chart-series-pattern-55",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--chart-color-55)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines90",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(180)"
    },
    "indicators-chart-series-pattern-56": {
        "id": "indicators-chart-series-pattern-56",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--chart-color-56)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-57": {
        "id": "indicators-chart-series-pattern-57",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--chart-color-57)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle90",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(135)"
    },
    "indicators-chart-series-pattern-58": {
        "id": "indicators-chart-series-pattern-58",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--chart-color-58)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-59": {
        "id": "indicators-chart-series-pattern-59",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--chart-color-59)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-60": {
        "id": "indicators-chart-series-pattern-60",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M10 0 V20 M0 10 H20",
                "stroke": "var(--chart-color-60)",
                "stroke-width": 10
            },
            {
                "tagName": "path",
                "d": "M20 0 V20 M0 20 H20",
                "stroke": "var(--chart-color-60)",
                "stroke-width": 2
            }
        ],
        "patternName": "diamonds",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.3) rotate(45)"
    },
    "indicators-chart-series-pattern-61": {
        "id": "indicators-chart-series-pattern-61",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-61)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(45)"
    },
    "indicators-chart-series-pattern-62": {
        "id": "indicators-chart-series-pattern-62",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-62)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles2",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(0)"
    },
    "indicators-chart-series-pattern-63": {
        "id": "indicators-chart-series-pattern-63",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--chart-color-63)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks135",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(135)"
    },
    "indicators-chart-series-pattern-64": {
        "id": "indicators-chart-series-pattern-64",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--chart-color-64)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines135",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(225)"
    },
    "indicators-chart-series-pattern-65": {
        "id": "indicators-chart-series-pattern-65",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--chart-color-65)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-66": {
        "id": "indicators-chart-series-pattern-66",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--chart-color-66)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle135",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(180)"
    },
    "indicators-chart-series-pattern-67": {
        "id": "indicators-chart-series-pattern-67",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--chart-color-67)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-68": {
        "id": "indicators-chart-series-pattern-68",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--chart-color-68)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-69": {
        "id": "indicators-chart-series-pattern-69",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M10 0 V20 M0 10 H20",
                "stroke": "var(--chart-color-69)",
                "stroke-width": 10
            },
            {
                "tagName": "path",
                "d": "M20 0 V20 M0 20 H20",
                "stroke": "var(--chart-color-69)",
                "stroke-width": 2
            }
        ],
        "patternName": "diamonds",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.3) rotate(45)"
    },
    "indicators-chart-series-pattern-70": {
        "id": "indicators-chart-series-pattern-70",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-70)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(45)"
    },
    "indicators-chart-series-pattern-71": {
        "id": "indicators-chart-series-pattern-71",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-71)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles2",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(0)"
    },
    "indicators-chart-series-pattern-72": {
        "id": "indicators-chart-series-pattern-72",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--chart-color-72)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-73": {
        "id": "indicators-chart-series-pattern-73",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--chart-color-73)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(90)"
    },
    "indicators-chart-series-pattern-74": {
        "id": "indicators-chart-series-pattern-74",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--chart-color-74)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-75": {
        "id": "indicators-chart-series-pattern-75",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--chart-color-75)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(45)"
    },
    "indicators-chart-series-pattern-76": {
        "id": "indicators-chart-series-pattern-76",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--chart-color-76)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-77": {
        "id": "indicators-chart-series-pattern-77",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--chart-color-77)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-78": {
        "id": "indicators-chart-series-pattern-78",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M10 0 V20 M0 10 H20",
                "stroke": "var(--chart-color-78)",
                "stroke-width": 10
            },
            {
                "tagName": "path",
                "d": "M20 0 V20 M0 20 H20",
                "stroke": "var(--chart-color-78)",
                "stroke-width": 2
            }
        ],
        "patternName": "diamonds",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.3) rotate(45)"
    },
    "indicators-chart-series-pattern-79": {
        "id": "indicators-chart-series-pattern-79",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-79)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(45)"
    },
    "indicators-chart-series-pattern-80": {
        "id": "indicators-chart-series-pattern-80",
        "width": 42,
        "height": 42,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 42,
                "height": 42,
                "fill": "var(--chart-color-80)"
            },
            {
                "tagName": "path",
                "d": "M10 4 L16 16 H4 Z",
                "fill": "var(--brand-color-White)",
                "stroke-width": 10
            }
        ],
        "patternName": "triangles2",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.2) rotate(0)"
    },
    "indicators-chart-series-pattern-81": {
        "id": "indicators-chart-series-pattern-81",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--chart-color-81)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks45",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(45)"
    },
    "indicators-chart-series-pattern-82": {
        "id": "indicators-chart-series-pattern-82",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--chart-color-82)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines45",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(135)"
    },
    "indicators-chart-series-pattern-83": {
        "id": "indicators-chart-series-pattern-83",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--chart-color-83)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-84": {
        "id": "indicators-chart-series-pattern-84",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--chart-color-84)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle45",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(90)"
    },
    "indicators-chart-series-pattern-85": {
        "id": "indicators-chart-series-pattern-85",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--chart-color-85)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-86": {
        "id": "indicators-chart-series-pattern-86",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--chart-color-86)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-chart-series-pattern-87": {
        "id": "indicators-chart-series-pattern-87",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M10 0 V20 M0 10 H20",
                "stroke": "var(--chart-color-87)",
                "stroke-width": 10
            },
            {
                "tagName": "path",
                "d": "M20 0 V20 M0 20 H20",
                "stroke": "var(--chart-color-87)",
                "stroke-width": 2
            }
        ],
        "patternName": "diamonds",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.3) rotate(45)"
    },
    "indicators-treemap-series-pattern-0": {
        "id": "indicators-treemap-series-pattern-0",
        "width": 12,
        "height": 12,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 12,
                "height": 12,
                "fill": "var(--sei2024-monochromatic-chart-color-0)"
            },
            {
                "tagName": "path",
                "d": "M 9,2 L 2,9",
                "transform": "rotate(45)",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 4
            }
        ],
        "patternName": "bricks0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-treemap-series-pattern-1": {
        "id": "indicators-treemap-series-pattern-1",
        "width": 20,
        "height": 20,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 20,
                "height": 20,
                "fill": "var(--sei2024-monochromatic-chart-color-1)"
            },
            {
                "tagName": "path",
                "d": "M0 20 L20 0 M-5 5 L5 -5 M15 25 L25 15",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 2
            }
        ],
        "patternName": "lines0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(90)"
    },
    "indicators-treemap-series-pattern-2": {
        "id": "indicators-treemap-series-pattern-2",
        "width": 10,
        "height": 10,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 10,
                "height": 10,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "circle",
                "x": 5,
                "y": 5,
                "r": 12,
                "fill": "none",
                "stroke": "var(--sei2024-monochromatic-chart-color-2)",
                "stroke-width": 20
            }
        ],
        "patternName": "dots",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-treemap-series-pattern-3": {
        "id": "indicators-treemap-series-pattern-3",
        "width": 35,
        "height": 35,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 35,
                "height": 35,
                "fill": "var(--sei2024-monochromatic-chart-color-3)"
            },
            {
                "tagName": "path",
                "d": "M0 17.5 Q8.75 7 17.5 17.5 T35 17.5",
                "fill": "none",
                "stroke": "var(--brand-color-White)",
                "stroke-width": 12.5,
                "stroke-linecap": "square"
            }
        ],
        "patternName": "squiggle0",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.125) rotate(45)"
    },
    "indicators-treemap-series-pattern-4": {
        "id": "indicators-treemap-series-pattern-4",
        "width": 27,
        "height": 27,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 27,
                "height": 27,
                "fill": "var(--sei2024-monochromatic-chart-color-4)"
            },
            {
                "tagName": "rect",
                "x": 9,
                "y": 9,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "rect",
                "x": 21,
                "y": 21,
                "width": 3,
                "height": 3,
                "fill": "var(--brand-color-White)"
            }
        ],
        "patternName": "squares",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    },
    "indicators-treemap-series-pattern-5": {
        "id": "indicators-treemap-series-pattern-5",
        "width": 17,
        "height": 17,
        "children": [
            {
                "tagName": "rect",
                "x": 0,
                "y": 0,
                "width": 17,
                "height": 17,
                "fill": "var(--brand-color-White)"
            },
            {
                "tagName": "path",
                "d": "M0 0 L17 17 M17 0 L0 17",
                "fill": "none",
                "stroke": "var(--sei2024-monochromatic-chart-color-5)",
                "stroke-width": 7
            }
        ],
        "patternName": "lattice",
        "tagName": "pattern",
        "patternUnits": "userSpaceOnUse",
        "patternTransform": "scale(0.5) rotate(0)"
    }
}